import React from 'react'
import { connect } from 'react-redux'
import Menu from './Menu'
import { AppState } from '../reducers'

const Header = ({ filters }) => {
    const isViewSelected = () => {
        return Object.keys(filters).filter(key => filters[key] === null).length === 0;
    }

    return (
        <div id="kr-header">
            <div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h1>Wybierz elementy systemu NIAGARA</h1>
                    {
                        process.env.NODE_ENV === 'development' &&
                        <p style={{color: '#e2201e', fontSize: '24px', fontWeight : 600}}>Środowisko testowe</p>
                    }
                </div>
                <h2 style={isViewSelected() ? {visibility: 'hidden'} : null}>Wybierz odpowiednie opcje, aby wyświetlić wszystkie elementy wybranego systemu.</h2>
            </div>
            <Menu />
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    filters: state.filters,
})

export default connect(mapStateToProps)(Header)
